//Importing Bar class from the vue-chartjs wrapper
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
//Exporting this so it can be used in other components
export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "options"],

  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.options);
      },
      deep: true
    }
  }
};
